/* eslint-disable max-len */
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import _ from 'lodash';
import { Observable, ReplaySubject, Subscription, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
@Component({
  selector: 'quick-assign-employee',
  templateUrl: './quick-assign-employee.component.html',
  styleUrls: ['./quick-assign-employee.component.scss']
})
export class QuickAssignEmployeeComponent implements OnInit, OnDestroy, OnChanges {

  @Input() prefillUsers: any[] = [];
  @Input() showUserTeamAndRole: boolean = true;
  @Input() spreadUserTeams?: boolean = false; //Pass true to show all user assigned teams
  @Output() selectedUsers: EventEmitter<any> = new EventEmitter();


  employees: Observable<any[]> = new Observable<any[]>();
  employeeValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  employeeFetching: boolean = false;
  employeeOptions: any[] = [];
  employeePagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  // eslint-disable-next-line @typescript-eslint/naming-convention
  employeeParamObj: any = { 'count': 10, 'page': 1, 'filter.is_assigned_to_team': true, 'populate_teams': true, 'filter.is_active': true };
  assignedEmployees: any[] = [];
  prefillUserData: any = null;
  employeeSearchSubscription: Subscription;

  constructor(
    private utilityService: UtilityService,
    private dataCollectorService: DataCollectorService,

  ) { }

  ngOnInit(): void {
    this.updateAssignedToList();
    this.initEmployeeSearchListner();
  }

  ngOnDestroy(): void {
    this.employeeSearchSubscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.prefillUsers) {
      this.updateAssignedToList();
    }
  }

  updateAssignedToList(): void {
    this.assignedEmployees = this.prefillUsers?.length ? [...this.prefillUsers] : [];
    if (this.assignedEmployees.length) {
      this.onEmployeeChange(null);
    }
  }

  onEmployeeChange(item: any): void {
    if (item) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const isUserAlreadySelected = this.assignedEmployees.filter((assignedEmployee: any) =>
        assignedEmployee.user.user_uid === item?.user.user_uid && (assignedEmployee.team.team_uid === item?.team.team_uid || !this.spreadUserTeams)).length;
      if (isUserAlreadySelected) {
        this.unassignEmployee(item);
      }
      else {
        this.assignedEmployees.push(item);
      }
    }
    if (this.assignedEmployees.length) {
      this.assignedEmployees.forEach((userDetails: any) => {
        if (userDetails?.user?.profile_picture) {
          userDetails['user']['hasValidProfilePicture'] = this.utilityService.hasValidProfilePicture(userDetails?.user?.profile_picture);
        }
      });
    }
    this.assignedEmployees = _.uniqWith(
      this.assignedEmployees,
      (userOne, userTwo) =>
        userOne.user.user_uid === userTwo.user.user_uid &&
        (userOne.team.team_uid === userTwo.team.team_uid && !this.spreadUserTeams)
    );
  }

  onEmployeeClear(): void {
    this.employees = this.getEmployees('');
  }
  onEmployeeSelectOpen(): void {
    this.employees = this.getEmployees('');
  }

  getEmployees(input: string): Observable<any[]> {
    this.employeePagination.keyword = input ? input : '';
    this.employeeParamObj['filter.keyword'] = this.employeePagination.keyword;
    this.employeeParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.employeeParamObj);
    this.employeeFetching = true;
    const userUrl = `${this.dataCollectorService.baseurl()}/user/all`;
    return this.dataCollectorService.getData(userUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          let employeeData: any[] = [];
          for (const element of response?.data) {
            if (this.spreadUserTeams) {
              const users = element?.teams.map((data: any) => ({ user: element, team: data, hasValidProfilePicture: this.utilityService.hasValidProfilePicture(element?.profile_picture) }));
              employeeData = [...employeeData, ...users];
            }
            else {
              // eslint-disable-next-line @typescript-eslint/naming-convention
              let team: any = { 'team_name': '' };
              if (element?.['teams']?.length) {
                team = element?.['teams'][0];
              }
              employeeData = [...employeeData, { user: element, team: team, hasValidProfilePicture: this.utilityService.hasValidProfilePicture(element?.profile_picture) }];
            }
          }
          this.employeePagination.loadingIndex = response.current_page;
          this.employeePagination.totalPage = response.total_pages;
          this.employeeOptions = employeeData;
          this.employeeFetching = false;
          return employeeData;
        }),
      );
  }

  initEmployeeSearchListner(): void {
    this.employeeSearchSubscription = this.employeeValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(500)).subscribe((term: string) => {
        this.employees = this.getEmployees((term || '').trim());
      });
  }

  onEmployeeScrollToEnd(): void {
    if (this.employeePagination.loadingIndex < this.employeePagination.totalPage) {
      this.employeePagination.loadingIndex++;
      this.employeeParamObj['filter.keyword'] = this.employeePagination.keyword;
      this.employeeParamObj['page'] = this.employeePagination.loadingIndex;
      this.employeeFetching = true;
      const urlParams = this.utilityService.constructParam(this.employeeParamObj);
      const userUrl = `${this.dataCollectorService.baseurl()}/user/all`;
      this.dataCollectorService.getData(userUrl, urlParams).subscribe(
        (response: any) => {
          let employeeData: any[] = [];
          for (const element of response?.data) {
            if (this.spreadUserTeams) {
              const users = element?.teams.map((data: any) => ({ user: element, team: data, hasValidProfilePicture: this.utilityService.hasValidProfilePicture(element?.profile_picture) }));
              employeeData = [...employeeData, ...users];
            }
            else {
              // eslint-disable-next-line @typescript-eslint/naming-convention
              let team: any = { 'team_name': '' };
              if (element?.['teams']?.length) {
                team = element?.['teams'][0];
              }
              employeeData = [...employeeData, { user: element, team: team, hasValidProfilePicture: this.utilityService.hasValidProfilePicture(element?.profile_picture) }];
            }
          }
          this.employeeFetching = false;
          this.employeeOptions = this.employeeOptions.concat(employeeData);
          this.employees = of(this.employeeOptions);
        }, (error: any) => {
          this.employeeFetching = false;
        });
    }
  }

  unassignEmployee(item: any): void {
    if (this.assignedEmployees?.length) {
      this.assignedEmployees = this.assignedEmployees?.filter(value => !((item?.user?.user_uid === value?.user?.user_uid) && (item?.team?.team_uid === value?.team?.team_uid || !this.spreadUserTeams)));
    }
  }

  isEmployeeAssigned(item: any): boolean {
    if (this.assignedEmployees?.length) {
      const selectedUser: any = this.assignedEmployees?.find(value => (item?.user?.user_uid === value?.user?.user_uid) && (item?.team?.team_uid === value?.team?.team_uid || !this.spreadUserTeams));
      return selectedUser;
    }
    return false;
  }

  onSaveEmployess(): void {
    const event = { isConfirmed: true, users: this.assignedEmployees };
    this.selectedUsers.emit(event);
  }

  onCancelAssignEmployees(): void {
    const event = { isConfirmed: false, users: [] };
    this.selectedUsers.emit(event);
  }
}
